import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { tap, map, switchMap } from "rxjs/operators";
import { PricingMatrix } from "./models/MatixModel";
import { table } from "console";

@Injectable({
  providedIn: "root",
})
export class PricingQoutationService {
  constructor(private httpClient: HttpClient) { }
  public MatriceSubject: BehaviorSubject<PricingMatrix[]> = new BehaviorSubject<
    any[]
  >(null);
  public Matrices$: Observable<
    PricingMatrix[]
  > = this.MatriceSubject.asObservable();

  public showSpinner: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(
    false
  );

  public showMatrixSpinner: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(
    false
  );

  editFromSpecification: boolean = false
  public ActivePageSubject: BehaviorSubject<string> = new BehaviorSubject<string>(
    "details"
  );
  public headerEditDuplicate: BehaviorSubject<any> = new BehaviorSubject<any>(null);

  public MatrixIdSubject: BehaviorSubject<number> = new BehaviorSubject<number>(null);
  public ShowSubNavSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
  editOrDuplicateCategory: any
  editOrDuplicateSpecification: any
  editOrDuplicateOrAddClassification: any
  isDuplicateFromClassificationList: boolean
  classificationId
  isDuplicate: boolean = false
  public GetMatrices() {
    this.showSpinner.next(true);
    return this.httpClient.get("/FormItem/GetAllFormItems").pipe(
      tap((response: any[]) => {
        this.MatriceSubject.next(<PricingMatrix[]>response);
        this.showSpinner.next(false);
      })
    );
  }

  public GetMatricesPaginated(culture, pageIndex, pageSize, SearchText) {
    this.showSpinner.next(true);
    return this.httpClient.get(`/Pricing/GetAllFormItemsWithClassificationPagination/${culture}?page=${pageIndex}&pageSize=${pageSize}&SearchText=${SearchText}`).pipe(
      tap((response: any[]) => {
        this.MatriceSubject.next(<PricingMatrix[]>response);
        this.showSpinner.next(false);
      })
    );
  }

  public GetSpecificationPaginated(culture, pageIndex, pageSize, matrixId) {
    this.showSpinner.next(true);
    return this.httpClient.get(`/Pricing/GetFormFieldByFormItemIdPagintaion/${culture}?MatrixId=${matrixId}&Page=${pageIndex}&PageSize=${pageSize}`).pipe(
      tap((response: any[]) => {
        this.MatriceSubject.next(<PricingMatrix[]>response);
        this.showSpinner.next(false);
      })
    );
  }
  getAllCulture() {
    return this.httpClient.get(`/Sites/GetUsedSiteCulturesByStatus/${2}`);
  }

  public GetClassificationPaginated(culture, pageIndex, pageSize, FormItemId, SearchText = '') {
    this.showSpinner.next(true);
    return this.httpClient.get(`/Pricing/GetClassificationsByFormItemIdPagintaion/cultureId=${culture}?FormItemId=${FormItemId}&Page=${pageIndex}&PageSize=${pageSize}&SearchText=${SearchText}`).pipe(
      tap((response: any[]) => {
        this.showSpinner.next(false);
      })
    );
  }

  public getMatrixById(FormItemId: number) {
    this.showSpinner.next(true);
    return this.httpClient.get(`/FormItem/GetFormItemsById/${FormItemId}`).pipe(
      tap((response) => {
        this.showSpinner.next(false);
      })
    );
  }
  public GetAllMatricesWithClassification(cultureId) {
    this.showSpinner.next(true);
    return this.httpClient.get(`/Pricing/GetAllFormItemsWithClassification/${cultureId}`).pipe(tap(res => { this.showSpinner.next(false); }))
  }
  public DeleteMatrix(FormItemId: number) {
    return this.httpClient
      .delete(`/FormItem/DeleteFormItems/${FormItemId}`)

  }

  public GetMatrixByIndex(matrixIndex: number): PricingMatrix {
    let MatricesList: any[] = this.MatriceSubject.getValue();
    return MatricesList[matrixIndex];
  }

  public deleteClassification(classificationId: number, matrixId: number) {
    return this.httpClient
      .delete(`/DynamicFormsAPI/DeleteClassification/${classificationId}`)
      .pipe(
        map((res) => {
                   if (res) {
            return classificationId;
          } else {
            // show alert
          }
        })
      );
  }

  //
  assignFormItemPermissions(data) {
    return this.httpClient.post(`/FormItem/AssignFormItemPermissions`, data);
  }
  assignedFormItemRoles(Id) {
    return this.httpClient.get(`/FormItem/AssignedFormItemRoles/${Id}`);

  }
  public GetPagenatedClassification(FormItemId: number, PaginationData: any) { //not completed yet : yazan
    return this.httpClient
      .post(`/DynamicFormsAPI/GetPaginatedClassifications/${FormItemId}`, {});
  }

  public GetClassificationById(classificationId) {
    this.showSpinner.next(true);
    return this.httpClient
      .get(`/DynamicFormsAPI/GetClassificationById/${classificationId}`)
      .pipe(
        map((response: any) => {
          this.showSpinner.next(false);
          
          response.criteriaList = (response.criteriaList as any[]).map(c => {
            return { ...c, subCategoryId: c.subCategory ? c.subCategory.id : null };
          });
          return response;
        })
      );
  }

  public upsertMatrix(matrixObj) {
    this.showSpinner.next(true);
    return this.httpClient.post(`/FormItem/UpsertFormItems`, matrixObj).pipe(
      map((res: any) => {
               this.showSpinner.next(false);
        let matrices: any = this.MatriceSubject.getValue();
        if (matrices) {
          let itemIndex = matrices.data.findIndex((item) => item.id == res.id);
          if (itemIndex == -1) {
            matrices.data.push(res);
          } else {
            matrices.data[itemIndex] = res;
          }
          this.MatriceSubject.next(matrices);
        }
        return res;
      })
    );
  }

  public setActivePage(pageName: string) {
    this.ActivePageSubject.next(pageName);
  }

  public upsertClassification(classObj) {
    this.showSpinner.next(true);
    return this.httpClient.post(
      `/DynamicFormsAPI/UpsertClassification`,
      classObj
    );
  }


  public deleteCriateria(id) {
    this.showSpinner.next(true);
    return this.httpClient.delete(`/DynamicFormsAPI/Criteria/${id}`);
  }

  public DuplicateMatrix(MatrixId: number) {
    this.showMatrixSpinner.next(true);
    return this.httpClient.get(`/PricingQuotation/DuplicateMatrix/${MatrixId}`)
      .pipe(
        tap((res: any) => {
          let matrices: any[] = this.MatriceSubject.getValue();
          if (matrices) {
            let itemIndex = matrices.findIndex((item) => item.id == MatrixId);
            matrices.splice(itemIndex, 0, res.result);

            this.MatriceSubject.next(matrices);
          }
          this.showMatrixSpinner.next(false);
          return res;
        })
      );
  }

}
